module.exports = __webpack_public_path__ + "img/Plant.d7da98a6.png";